import template from './header.pug';

export const HeaderComponent = {
  template,
  bindings: {
    totalPages: '<',
    totalCount: '<',
    page: '<',
    perPage: '<?',
    afterPageChange: '&',
    isModal: '<?'
  },
  transclude : true,
  controller: class HeaderComponent {
    constructor() {
      'ngInject';
    }

    $onInit() {
      this.enabledEdit = true;
      console.log('header', this.totalPages, this.totalCount, this.page, this.perPage);
    }

    change({ page }) {
      this.afterPageChange({
        $event: { page }
      });
    }
  }
};
